// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3Drgy","fileBtn":"File_fileBtn__1UeJa","closeBtn":"File_closeBtn__20Z2k","fileSelected":"File_fileSelected__2KwLx","disabled":"File_disabled__32VYH"};